import { useLocation } from "react-router-dom";

function NullValueCell({ cell, row }: { cell: any; row: any }): JSX.Element {
  const location = useLocation();
  if (location?.pathname === "/access/shipments/unshipped-orders") {
    return <td>{row.original.specimenId ? row.original.specimenId : "N/A"}</td>;
  }
  return (
    <td>
      {row.original.confirmationCode ? row.original.confirmationCode : "N/A"}
    </td>
  );
}

export default NullValueCell;
